import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Mail, Phone } from "lucide-react";
export default function MeetTheTeam() {
  const teamMembers = [{
    id: 1,
    name: "Anthony Meaburn",
    position: "Clinical Specialist Physiotherapist",
    qualification: "BSc (Hons) Physiotherapy, MCSP, HCPC Registered",
    bio: "Anthony is an experienced musculoskeletal physiotherapist with over 20 years in MSK health, supporting people with pain, injury, and long-term conditions. Having worked across the NHS and private practice, he takes a practical, evidence-based approach focused on understanding the person, not just the problem. His aim is simple: help people move better, feel better, and regain confidence in their bodies.",
    image: "https://immune-minnow.10web.cloud/wp-content/uploads/2025/10/Cartoon-2.png",
    email: "anthony@alignphysiotherapy.co.uk",
    phone: "07463682889"
  }, {
    id: 2,
    name: "Isabella",
    position: "Sports Massage Therapist",
    qualification: "Level 4 Diploma in Sports Massage Therapy, ",
    bio: "Isabella is a Level 4 Qualified Massage Therapist who works with people from all walks of life, not just athletes.  She helps clients manage aches, pains, muscle tension and everyday discomfort, as well as supporting recovery and movement. Each treatment is tailored to how your body feels on the day and she always takes a friendly, professional approach to help you feel more comfortable, relaxed and moving better. ",
    image: "https://immune-minnow.10web.cloud/wp-content/uploads/2026/01/unnamed.jpg",
    email: "appointments@alignphysiotherapy.co.uk",
    phone: "07463682889"
  }, {
    id: 3,
    name: "Ellie",
    position: "Lead Pelvic Health Physiotherapist",
    qualification: "BSc Physiotherapy,, HCPC Registered, POGP Affiliated",
    bio: "Ellie is a specialist Pelvic Health Physiotherapist with extensive experience supporting women through pregnancy, postnatal recovery and pelvic floor rehabilitation. She is a POGP-affiliated physiotherapist (Pelvic Obstetric and Gynaecological Physiotherapy), ensuring her treatment is guided by the latest evidence and best practice. Ellie has a particular interest in helping women manage symptoms such as bladder leakage, pelvic floor weakness, pelvic pain and recovery after childbirth. She provides thorough assessments and personalised rehabilitation programmes designed to restore strength, confidence and return to normal activities and exercise. Ellie understands that pelvic health concerns can feel difficult to talk about, and she creates a supportive and comfortable environment where patients feel listened to and understood.\n\nCommon conditions Ellie treats:\n• Bladder leakage\n• Pelvic organ prolapse\n• Postnatal recovery\n• Pelvic floor weakness or overactivity\n• Return to exercise after pregnancy",
    image: "https://alignphysiotherapy.co.uk/wp-content/uploads/2026/03/Ellie-Picture.jpeg?v=2495wmkydc4",
    email: "ellie@alignphysiotherapy.co.uk",
    phone: "07463682889"
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary mb-4 tracking-wide">
            Meet the Team
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Our experienced physiotherapists and sports massage therapists are dedicated to providing evidence-based, personalised care to help you move better and feel better.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className="overflow-hidden hover-lift border border-border shadow-soft bg-white animate-fade-in-up-delay-100">
              <div className="relative w-full aspect-square overflow-hidden">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
              </div>

              <CardHeader className="border-b border-border/30">
                <CardTitle className="text-2xl text-foreground font-display">
                  {member.name}
                </CardTitle>
                <CardDescription className="text-primary font-semibold text-base">
                  {member.position}
                </CardDescription>
                <p className="text-sm text-muted-foreground mt-2">
                  {member.qualification}
                </p>
              </CardHeader>

              <CardContent className="space-y-4">
                <p className="text-base text-foreground leading-relaxed">
                  {member.bio}
                </p>

                <div className="space-y-2 pt-2 border-t border-border/30">
                  <Link to={`mailto:${member.email}`} className="flex items-center gap-2 text-sm text-accent hover:text-accent-hover transition-colors duration-150">
                    <Mail className="w-4 h-4" />
                    <span>{member.email}</span>
                  </Link>
                  <Link to={`tel:${member.phone}`} className="flex items-center gap-2 text-sm text-accent hover:text-accent-hover transition-colors duration-150">
                    <Phone className="w-4 h-4" />
                    <span>{member.phone}</span>
                  </Link>
                </div>

                <div className="pt-4">
                  <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary-hover shadow-soft transition-all duration-150">
                    <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">Book Appointment</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center mt-12 animate-fade-in-up-delay-200">
          <p className="text-base text-muted-foreground mb-6">
            Ready to start your journey to better movement and recovery?
          </p>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover shadow-medium transition-all duration-150">
            <Link to="/ContactPage">Contact Us Today</Link>
          </Button>
        </div>
      </div>
    </section>;
}